import type { QueryClient } from '@tanstack/react-query';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { StartAPetitionDataQuery, StartAPetitionDataQueryVariables } from './api.graphql';
import { StartAPetitionData } from './api.graphql';
import { findOrCreateDraft } from './findOrCreateDraft';

type Draft = Awaited<ReturnType<typeof findOrCreateDraft>>;
export type StartAPetitionPageData = Pick<StartAPetitionDataQuery, 'featureConfigs' | 'experiments'> & {
	draft: Draft;
};

export async function getStartAPetitionPageData(
	{ gql: { fetch }, errorReporter }: UtilityContext,
	queryClient: QueryClient,
): Promise<StartAPetitionPageData> {
	const dataPromise = fetch<StartAPetitionDataQuery, StartAPetitionDataQueryVariables>({
		query: StartAPetitionData,
		rejectOnError: true,
	});

	const [{ data }, draft] = await Promise.all([
		dataPromise,
		findOrCreateDraft({ errorReporter, gqlClient: { fetch }, queryClient }),
	]);

	return {
		draft,
		featureConfigs: data.featureConfigs,
		experiments: data.experiments,
	};
}
